import {
  Field,
  FieldProps,
  FluentProvider,
  Input,
  InputOnChangeData, makeStyles,
  PartialTheme,
  webDarkTheme,
  webLightTheme,
} from "@fluentui/react-components";

import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";

const useStyles = makeStyles({
  root: {
    fontWeight: 600
  },
});

interface TextFieldProps {
  rcName?: string;
  theme?: string;
  name?: string;
  value?: string;
  rcRole?: string[];
  requireRoles?: string[];
  disabled?: boolean;
  type?: 'text' | 'email' | 'password' | 'search' | 'tel' | 'url' | 'date' | 'datetime-local' | 'month' | 'number' | 'time' | 'week';
  onChangeText?: (
    event: React.ChangeEvent<HTMLInputElement>,
    newValue?: string
  ) => void;
  placeholder?: string;
}

const TextField = (props: TextFieldProps & FieldProps) => {
  const styles = useStyles();
  const renderTheme: PartialTheme =
    props.theme === "dark" ? webDarkTheme : webLightTheme;
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles
  );

  const onChange = (
    ev: React.ChangeEvent<HTMLInputElement>,
    data: InputOnChangeData
  ) => {
    if (props.onChangeText) {
      props.onChangeText(ev, data.value);
    }
  };
  return (
    <FluentProvider
      theme={
        props.theme === "dark"
          ? webDarkTheme
          : {
              ...renderTheme,
              colorCompoundBrandStroke: "rgb(70, 101, 136)",
              colorCompoundBrandStrokeHover: "rgb(21, 51, 89)",
            }
      }
    >
      <Field
        label={props.label}
        validationMessage={props.validationMessage}
        validationMessageIcon={props.validationMessageIcon}
        validationState={props.validationState}
        required={props.required}
        style={props.style}
        className={`${props.className} ${styles.root}`}
      >
        <Input
          name={props.name}
          onChange={onChange}
          value={props.value}
          disabled={props.disabled || !isCanBeVisible}
          placeholder={props.placeholder}
          type={props.type}
        />
      </Field>
    </FluentProvider>
  );
};

export default TextField;
